import {gql} from '@apollo/client';

export default gql`
  mutation contactPublisher($input: ContactPublisherInput!) {
    authed {
      success
    }
    contactPublisher(input: $input) {
      success
    }
  }
`;
